(() => {
  const initialize = (story) => {
    if (story.dataset.initialized === "true") return;
    story.dataset.initialized = "true";

    const items = story.querySelectorAll("[data-reveal]");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reducedMotion || !("IntersectionObserver" in window)) {
      items.forEach((item) => item.classList.add("is-revealed"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.1 }
    );

    items.forEach((item) => observer.observe(item));
  };

  const initializeAll = (root = document) => {
    if (root.matches?.("[data-why-larson-story]")) initialize(root);
    root.querySelectorAll?.("[data-why-larson-story]").forEach(initialize);
  };

  initializeAll();
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
